import { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import { CartContext } from '../context/CartContext';
import ProductCard from '../components/ProductCard';
import config from '../config';

const Shop = () => {
    const { user } = useContext(AuthContext);
    const { getTotalItems } = useContext(CartContext);
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState('all');

    const categories = [
        { value: 'all', label: 'All Products' },
        { value: 'chess-sets', label: 'Chess Sets' },
        { value: 'boards', label: 'Boards' },
        { value: 'pieces', label: 'Pieces' },
        { value: 'clocks', label: 'Clocks' },
        { value: 'books', label: 'Books' },
        { value: 'accessories', label: 'Accessories' }
    ];

    useEffect(() => {
        fetchProducts();
    }, [selectedCategory]);

    const fetchProducts = async () => {
        try {
            setLoading(true);
            const url = selectedCategory === 'all'
                ? `${config.API_URL}/products`
                : `${config.API_URL}/products?category=${selectedCategory}`;

            const res = await axios.get(url);
            setProducts(res.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching products:', error);
            setLoading(false);
        }
    };

    const handleDelete = async (productId) => {
        if (!window.confirm('Are you sure you want to delete this product?')) {
            return;
        }

        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${config.API_URL}/products/${productId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProducts(products.filter(product => product.id !== productId));
            alert('Product deleted successfully!');
        } catch (error) {
            console.error('Error deleting product:', error);
            alert('Failed to delete product. Please try again.');
        }
    };

    const handleEdit = (productId) => {
        navigate(`/edit-product/${productId}`);
    };

    if (loading) {
        return <div className="container">Loading products...</div>;
    }

    return (
        <div className="shop-page" style={{ backgroundColor: '#fbf5ec', minHeight: '100vh', paddingTop: '2rem', paddingBottom: '4rem' }}>
            <div className="container">
                {user && (
                    <Link to="/add-product" className="floating-action-btn">
                        + Add Product
                    </Link>
                )}

                <div className="shop-header">
                    <h1>Chess Shop</h1>
                    <p>Premium chess equipment for players of all levels</p>
                </div>

                <div className="shop-filters">
                    <div className="filter-buttons">
                        {categories.map(cat => (
                            <button
                                key={cat.value}
                                className={`filter-btn ${selectedCategory === cat.value ? 'active' : ''}`}
                                onClick={() => setSelectedCategory(cat.value)}
                            >
                                {cat.label}
                            </button>
                        ))}
                    </div>
                </div>

                {products.length === 0 ? (
                    <div className="no-products">
                        <p>No products found in this category.</p>
                    </div>
                ) : (
                    <div className="product-grid">
                        {products.map(product => (
                            <ProductCard
                                key={product.id}
                                product={product}
                                user={user}
                                onDelete={handleDelete}
                                onEdit={handleEdit}
                            />
                        ))}
                    </div>
                )}
            </div>

            {/* Floating Cart Button - Only shows when cart has items */}
            {getTotalItems() > 0 && (
                <Link to="/cart" className="floating-cart-btn" aria-label="View Cart">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" fill="currentColor" />
                    </svg>
                    <span className="cart-badge">{getTotalItems()}</span>
                </Link>
            )}
        </div>
    );
};

export default Shop;
